import React from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'
import App from './App'
import registerServiceWorker from './registerServiceWorker'
import 'core-js/es6/map'
import 'core-js/es6/set'
import 'core-js/es6/string'
import 'raf/polyfill'

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>, document.getElementById('root'))
registerServiceWorker()
